import { Component } from '@angular/core';

@Component({
  selector: 'app-required-screen-reader',
  template: '<span class="sr-only">&nbsp;Required.</span>'
})
export class ScreenReaderRequiredComponent {
}
